import React from "react";

export function SelfEmployedIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44.45 45.02"
      width="30"
      height="30"
      fill="white"
      {...props}
    >
      <path
        className="cls-1"
        d="m44.45,45.02l-3.67-3.05-3.64,2.6-3.67-2.62-3.66,2.62-3.67-2.62-3.68,2.63-3.24-2.63-3.93,2.62-3.28-2.62-3.87,2.61-3.72-2.62-4.42,2.95V0h44.45v45.02Zm-40.02-4.29l3.72,2.62,3.91-2.63,3.29,2.62,3.93-2.62,3.22,2.61,3.65-2.6,3.67,2.62,3.66-2.62,3.67,2.62,3.69-2.63,2.62,2.18V1H1v42.02l3.44-2.29Z"
      />
      <path
        className="cls-1"
        d="m39.22,11.47h-19.32v-6.24h19.32v6.24Zm-18.32-1h17.32v-4.24h-17.32v4.24Z"
      />
      <path
        className="cls-1"
        d="m39.22,22.27h-6.04v-3.42h6.04v3.42Zm-5.04-1h4.04v-1.42h-4.04v1.42Z"
      />
      <path
        className="cls-1"
        d="m39.22,29.79h-6.04v-3.42h6.04v3.42Zm-5.04-1h4.04v-1.42h-4.04v1.42Z"
      />
      <path
        className="cls-1"
        d="m39.22,37.32h-6.04v-3.42h6.04v3.42Zm-5.04-1h4.04v-1.42h-4.04v1.42Z"
      />
      <rect className="cls-1" x="6.36" y="20.94" width="18.36" height="1" />
      <rect className="cls-1" x="6.36" y="26.69" width="19.27" height="1" />
      <rect className="cls-1" x="6.36" y="33.51" width="16.2" height="1" />
      <rect className="cls-1" x="5.12" y="14.85" width="34.53" height="1" />
      <rect className="cls-1" x="29.06" y="14.78" width="1" height="23.28" />
      <path
        className="cls-1"
        d="m12.79,9.07H4.35v-3.48h8.45v3.48Zm-7.45-1h6.45v-1.48h-6.45v1.48Z"
      />
    </svg>
  );
}
